exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-success[data-v-51c1f7a8]{width:100vw;min-height:50px;color:#155724;background-color:#d4edda;position:fixed;border:1px solid transparent;top:0;z-index:999999;display:flex;align-items:center;justify-content:center;font-weight:700}.close[data-v-51c1f7a8]{position:absolute;top:0;right:6px;padding:.75rem 1.25rem;color:inherit;background-color:transparent;border:0;float:right;font-size:1.5rem;font-weight:700;line-height:1;text-shadow:0 1px 0 #fff;opacity:.5}@media screen and (max-width:768px){.close[data-v-51c1f7a8]{right:-14px}.alert-success[data-v-51c1f7a8]{padding:5px 20px 5px 10px;font-size:14px;line-height:18px}}", ""]);

// exports
